export default `<p>Defi借贷池采用动态分级年化收益率（APY）机制。为最大限度提高资金效率，该合约引入了“每日区间上限结算”机制，当前收益按当前规则计算。系统将自动匹配您持有层级对应的最高收益。</p>

<h2>一、收益机制说明</h2>
<p>当您完成钱包授权并由平台按约定转入借款本金后，系统会生成对应的借款记录。每个自然日，平台依据以下规则计算该记录的收益：</p>
<ul>
  <li><strong>借款本金：</strong>该笔已转入并记录的 USDT 金额；</li>
  <li><strong>档位利率：</strong>根据该笔本金所在区间匹配日化收益率，区间按最大值结算；</li>
  <li><strong>日收益：</strong>借款本金 × 实际日化收益率 ÷ 100；</li>
  <li><strong>最新配置：</strong>后台调整档位后，当前利息按最新生效规则重新计算。</li>
</ul>
<p>平台收益提现仅影响账户可提现余额及复利累计基数，<strong>不影响链上钱包余额</strong>。收益按<strong>每日一次完整日化利率</strong>计算，后台配置的多个时点仅用于当日收益更新与展示，不会重复计算日化收益。收益累计计入账户，可在「资产 → 结算订单」中查看明细。历史收益不代表未来表现。</p>

<h2>二、收益阶梯表</h2>
<p>下表展示 <strong>Defi Lending Pool</strong> 当前生效的借款本金档位与对应日化收益率。单笔借出本金越高，可匹配的档位利率越高。表中利率均为<strong>日化百分比</strong>，非年化 APY。</p>
<!-- YIELD_TIER_TABLE -->
<p><strong>说明：</strong>每笔借款按该笔<strong>借出本金</strong>独立匹配唯一档位。同一用户有多笔借款时分别计算，再汇总展示本金、利息和本息合计。</p>

<h2>三、档位匹配规则</h2>
<ul>
  <li>完成链上授权并实际转入后生成的借款记录参与计息；</li>
  <li>低于 100 USDT 仍可借出，但实际日化利率为 0%；</li>
  <li>每个档位对应一个 USDT 本金区间，每笔借款自动匹配唯一适用档位；</li>
  <li>若某档位配置为区间利率，则统一按该区间的<strong>最大日化利率</strong>结算；</li>
  <li>档位配置可由平台运营方调整，变更仅对后续结算生效，不影响历史订单。</li>
</ul>

<h2>四、结算与展示</h2>
<h3>4.1 结算周期</h3>
<ul>
  <li><strong>计息频率：</strong>每个已授权资产每日按完整日化利率计息一次，多个展示时点不会重复计息；</li>
  <li><strong>首次结算：</strong>当日完成授权的钱包，从次日起开始计息结算；</li>
  <li><strong>订单字段：</strong>结算金额、币种（USDT / USDC）、适用利率、结算时间。</li>
</ul>
<h3>4.2 资产页指标</h3>
<p>在「资产」页可查看<strong>累计收益</strong>（历史结算总和）与<strong>今日收益</strong>（当日已结算部分），数据以系统订单记录为准。</p>

<h2>五、如何在 Defi Lending Pool 开始获取收益</h2>
<ol>
  <li>登录账户并连接兼容的 Web3 钱包；</li>
  <li>在钱包中确认 USDT 的 <strong>Approve（授权）</strong> 交易；</li>
  <li>平台按双方约定转入本金后，系统生成借款记录；</li>
  <li>每笔本金自动匹配收益档位，区间按上限计算；</li>
  <li>在「资产」页查看在借本金、当前利息与本息合计。</li>
</ol>

<h2>六、风险提示</h2>
<p><strong>Defi Lending Pool</strong> 采用非托管模式，平台不保管用户私钥。链上授权存在智能合约及市场风险，档位利率、池容量与结算结果可能发生变化。参与前请仔细阅读「规则与安全」页面。</p>

<p>— 档位利率数据同步自平台后端配置，页面展示仅供参考；最终结算金额以每日订单记录为准。</p>`
